/**
 * /industrie/operations — Hub des opérations CEE industrielles
 *
 * Liste les 8 opérations principales (utilités IND-UT + bâti IND-BA +
 * audit énergétique réglementaire) éligibles aux primes CEE secteur
 * Industrie. Chaque carte renvoie vers la fiche éditoriale dédiée
 * `/industrie/operations/[slug]`.
 *
 * Composant générique tone-aware (CORPORATE) :
 *   AudienceParcoursHub
 */

import { AudienceParcoursHub } from '../../../components/parcours/AudienceParcoursHub';
import { OPERATIONS_INDUSTRIE } from '../../../config/operations-industrie';

export default function IndustrieOperationsHubPage() {
  return (
    <AudienceParcoursHub
      audienceId="industrie"
      segment="operations"
      segmentLabel="Utilités & process"
      items={OPERATIONS_INDUSTRIE}
      heroEyebrow="Catalogue 2026 · 7 travaux éligibles + 1 audit obligatoire"
      heroHeadline="Vos opérations industrielles"
      heroHeadlineAccent="éligibles aux CEE IND"
      heroIntro="Variateurs de vitesse, moteurs haute efficacité (classes IE3/IE4), optimisation de l'air comprimé, récupération de chaleur fatale, calorifugeage, chaufferie de process, éclairage LED, audit énergétique réglementaire (norme NF EN 16247-1) : les 8 leviers techniques que nos auditeurs et bureaux d'études thermiques partenaires mobilisent en priorité sur un site industriel."
      primaryCta={{ label: 'Diagnostic primes énergie industrielles', href: '/industrie/diagnostic-cee' }}
      secondaryCta={{ label: 'Catalogue fiches industrie', href: '/cee/fiches?secteur=IND' }}
      bullets={['Sources officielles citées', "Bureau d'études thermique partenaire", 'Compatible certification énergie ISO 50001']}
      gridEyebrow="Utilités · bâti industriel · conformité"
      gridTitle="Les opérations à étudier en priorité sur un site industriel"
      ctaFinalTitle="Par où commencer sur votre site ?"
      ctaFinalDescription="À partir de votre numéro SIRET, on identifie les opérations éligibles sur vos utilités et votre bâti industriel (fiches IND-UT et IND-BA), on classe les travaux par retour sur investissement et délai de rentabilité, et on chiffre une fourchette de prime pour votre dossier d'investissement."
    />
  );
}
